import { ActionIcon, ActionIconProps, Group, Stack, Text } from "@mantine/core";
import "./ActionIconGroup.css";

interface ActionIconGroupProps {
  iconSize?: string | number;
  items: { icon: JSX.Element; label: string; value: string }[];
  labelFontSize?: string | number;
  onClick: (value: string) => void;
  size?: ActionIconProps["size"];
  value: string;
}

export const ActionIconGroup = (props: ActionIconGroupProps) => {
  const {
    iconSize,
    items,
    labelFontSize,
    onClick,
    value: selectedItemValue,
    size,
  } = props;

  return (
    <Group className="trkbk-action-button-group" grow wrap="nowrap">
      {items.map(({ icon, label, value }) => {
        const isSelected = value === selectedItemValue;

        return (
          <ActionIcon
            key={label}
            onClick={() => {
              onClick(value);
            }}
            size={size ?? 60}
            variant={isSelected ? "filled" : "transparent"}
            sx={(theme, u) => ({
              "&:hover": {
                [u.dark]: {
                  backgroundColor: isSelected
                    ? theme.primaryColor[7]
                    : theme.colors.dark[4],
                },
                [u.light]: {
                  backgroundColor: isSelected
                    ? theme.primaryColor[8]
                    : theme.colors.gray[1],
                },
              },
              [u.dark]: {
                color: isSelected ? "white" : theme.colors.gray[4],
              },
              [u.light]: {
                color: isSelected ? "white" : theme.colors.dark[3],
              },
            })}
          >
            <Stack
              gap="xs"
              sx={{
                fontSize: iconSize ?? "1.8rem",
                overflow: "hidden",
                padding: "5px",
              }}
            >
              {icon}
              <Text
                inline
                className="trkbk-action-button-label"
                sx={(_, u) => ({
                  [u.dark]: {
                    fontColor: isSelected ? "white" : "inherit",
                  },
                  [u.light]: {
                    fontColor: isSelected ? "white" : "#495057",
                  },
                  fontSize: labelFontSize ?? "0.8rem",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                })}
              >
                {label}
              </Text>
            </Stack>
          </ActionIcon>
        );
      })}
    </Group>
  );
};
